import React from 'react';
import { FaBoxOpen } from 'react-icons/fa';

interface EmptyStateProps {
  title?: string;
  message: string;
}

const EmptyState = ({ title, message }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full min-h-full py-10 px-6 text-center">
      <FaBoxOpen className="w-20 h-20 text-gray-400 mb-4" />
      {title && <h2 className="text-2xl font-semibold mt-6 mb-2">{title}</h2>}
      {message && <p className="text-gray-600">{message}</p>}
    </div>
  );
};

export default EmptyState;
